import { CORE_ACTION } from "../types/CoreAction";
import { DownloadSnackBarProps } from "@modules/shared/DownloadSnackBarProvider/DownloadSnackBar";

const addDownloadSnack = (snackBars: DownloadSnackBarProps) => {
  return {
    type: CORE_ACTION.ADD_DOWNLOAD_SNACK,
    payload: snackBars,
  };
};

export default addDownloadSnack;
